import './styles';

import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';

import { Box } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';


import AuthenticatedRoute from "./routes/authentication";
import NonAuthenticatedRoute from "./routes/notAuthentication";
import { theme } from './themes';
import useCloseToast from './Hooks/useCloseToast';
import useDetectDuplicateTab from './Hooks/useDetectDuplicateTab';



function App() {


  const {
    token,
    toastOpen
  } = useCloseToast();

 // useDetectDuplicateTab();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Box

          sx={
            {
              display: toastOpen ? "block" : "none",
              position: 'fixed',
              zIndex: 9999,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              right: 0,
              bottom: 0,
              top: 0,
              left: 0
            }
          }
        >
        </Box>

        <ToastContainer
          autoClose={5000}
          position="top-center"
          theme="light"
          hideProgressBar={false}
          style={{ width: "auto" }}
        />
        {token ? <AuthenticatedRoute /> : <NonAuthenticatedRoute />}

      </ThemeProvider>
    </StyledEngineProvider>

  )
}

export default App;
